import authApi, { makeAuthRequest } from '@/config/authApi.config';
import publicApi from '@/config/publicApi.config';
import { SignInApiResponse } from '@/types/api/auth';

const SERVICE_PATH = '/auth';

export const signIn = async ({
  email,
  password,
  authType,
}: {
  email: string;
  password: string;
  authType: 'EMAIL' | 'GOOGLE';
}) => {
  const res = await publicApi<SignInApiResponse>({
    method: 'POST',
    url: `${SERVICE_PATH}/login`,
    data: {
      email,
      password,
      authType,
    },
  });

  return res;
};

export const signInWithGoogle = async ({
  email,
  googleId,
  name,
  avatar,
}: {
  email?: string | null;
  googleId?: string | null;
  name?: string | null;
  avatar?: string | null;
}) => {
  const res = await publicApi<SignInApiResponse>({
    method: 'POST',
    url: `${SERVICE_PATH}/login-google`,
    data: {
      email,
      googleId,
      name,
      avatar,
    },
  });

  return res;
};

export const refreshToken = async () => {
  const res = await makeAuthRequest({
    method: 'GET',
    isShowError: false,
    path: `${SERVICE_PATH}/refresh-token?type=renew-when-call-permissions`,
    isRequireToken: true,
    isWithRefresh: true,
  });

  return res;
};

export const forgotPassword = async ({ email }: { email: string }) => {
  const res = await publicApi({
    method: 'POST',
    url: `${SERVICE_PATH}/forgot-password`,
    data: { email },
  });

  return res;
};

export const resetPassword = async ({ token, password }: { password: string; token: string }) => {
  const res = await publicApi({
    method: 'POST',
    url: `${SERVICE_PATH}/reset-password?token=${token}`,
    data: { password },
  });

  return res;
};

export const logoutApi = async () => {
  const res = await makeAuthRequest({
    method: 'POST',
    path: `${SERVICE_PATH}/logout`,
  });

  return res;
};
